var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { InlineChildren } from '@doordash/design-language';
import styled from 'styled-components';
export var PhoneContainer = styled(InlineChildren).attrs({
  size: InlineChildren.Sizes.XxSmall
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & > *:first-child {\n    flex-shrink: 2;\n    min-width: 128px;\n  }\n  & > *:last-child {\n    flex-grow: 1;\n    flex-shrink: 1;\n  }\n"])));